__webpack_require__.hmrF = function() { return "./assets/hot-update.json"; };